export const environment = {
  production: false,
  baseURL: 'https://mobiletest.aswanheartcentre.com:', // insecure http://sm-goals.com:8080
  port: 8443
}
